import { useEffect, useState } from 'react';
import { downloadImageBlob } from '../../api/providers';

const AuthenticatedImage = ({ filePath, orgId, alt = '', fallback = null, ...imageProps }) => {
  const [objectUrl, setObjectUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let createdUrl = null;

    setObjectUrl(null);
    setFailed(false);

    if (filePath && orgId) {
      downloadImageBlob(filePath, orgId)
        .then((blob) => {
          if (!active) return;
          createdUrl = URL.createObjectURL(blob);
          setObjectUrl(createdUrl);
        })
        .catch(() => {
          if (active) setFailed(true);
        });
    }

    return () => {
      active = false;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [filePath, orgId]);

  if (!objectUrl || failed) return fallback;

  return <img {...imageProps} src={objectUrl} alt={alt} onError={() => setFailed(true)} />;
};

export default AuthenticatedImage;